import type { ConnectionMode } from '../../shared/types';
import type { HealthState } from '../lib/ollama-client';

interface Props {
  mode?: ConnectionMode;
  // Either a typed health-check result (when we have one) or a simple status keyword.
  state?: HealthState['status'] | 'idle' | 'checking';
  health?: HealthState | null;
  tiny?: boolean;
}

const MODE_LABEL: Record<ConnectionMode, string> = {
  loopback: 'Loopback',
  proxy: 'Proxy',
  lan: 'LAN',
};

interface UiState {
  label: string;
  cls: string;
  live: boolean;
}

function uiFor(state: Props['state']): UiState {
  switch (state) {
    case 'ok':           return { label: 'Connected',         cls: 'pill-green',   live: true  };
    case 'checking':     return { label: 'Checking…',         cls: 'pill-blue',    live: true  };
    case 'cors_blocked': return { label: 'CORS blocked',      cls: 'pill-amber',   live: false };
    case 'ok_no_model':  return { label: 'Model missing',     cls: 'pill-amber',   live: false };
    case 'refused':      return { label: 'Daemon down',       cls: 'pill-red',     live: false };
    case 'idle':
    default:             return { label: 'Idle',              cls: 'pill-neutral', live: false };
  }
}

export function ConnectionBadge({ mode = 'loopback', state, health, tiny = false }: Props) {
  // Prefer `health` if provided (richer); fall back to the simple `state` prop.
  const effective = health?.status ?? state ?? 'idle';
  const ui = uiFor(effective);
  return (
    <span className={`pill ${ui.cls}`} style={tiny ? { padding: '3px 8px' } : undefined}>
      <span className={`dot ${ui.live ? 'dot-live' : ''}`} />
      <span style={{ opacity: 0.85 }}>{MODE_LABEL[mode]}</span>
      <span style={{ opacity: 0.4 }}>·</span>
      <span>{ui.label}</span>
    </span>
  );
}
